export default {
      id: "city-icon-1-usage",
      viewBox: "0 0 102 80",
      url: __webpack_public_path__ + "sprite.svg#city-icon-1",
      toString: function () {
        return this.url;
      }
    }